// extracted by mini-css-extract-plugin
export var results = "style-module--results--6fedf";
export var results__item = "style-module--results__item--50cf9";
export var results__item1 = "style-module--results__item-1--01aaa";
export var results__item2 = "style-module--results__item-2--14495";
export var results__item3 = "style-module--results__item-3--ccb19";
export var results__itemBody = "style-module--results__item-body--119d0";
export var results__itemHeader = "style-module--results__item-header--fb37b";
export var results__itemList = "style-module--results__item--list--30d39";
export var results__itemTitle = "style-module--results__item--title--1a634";
export var results__list = "style-module--results__list--f19b2";
export var results__title = "style-module--results__title--96542";
export var results__wrapper = "style-module--results__wrapper--e4272";